<ng-template #ref>
  <ng-content></ng-content>
</ng-template>
